export const basePages = {
  home: 'Inicio',
  login: 'Iniciar Sesión',
  logout: 'Cerrar Sesión',
  forbidden: 'Acceso Denegado',
  notFound: 'Página No Encontrada',
} as const
